async function discountAdjustment(productIdToCheck) {
  console.log("Checking cart for product ID:", productIdToCheck);
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const cartJSON = await response.json();
    console.log("Cart JSON fetched:", cartJSON);

    const exists = cartJSON.items.some(item => item.product_id == productIdToCheck);
    console.log(`Product ID ${productIdToCheck} exists in cart:`, exists);

    return exists;
  } catch (error) {
    console.error('Error fetching cart:', error);
    return false;
  }
}

async function priceAdjustment(productIdToCheck) {
  console.log("Starting price adjustment for product ID:", productIdToCheck);
  const exists = await discountAdjustment(productIdToCheck);
  console.log("Discount exists:", exists);

  const priceDivs = document.querySelectorAll('.price_div');
  console.log("Price divs found:", priceDivs.length);

  priceDivs.forEach(div => {
    const priceMain = div.querySelector('[data-price]');
    if (!priceMain) return;

    const existingDiscount = div.querySelector('.discounted_price');
    if (existingDiscount) existingDiscount.remove();

    if (exists) {
      const cs_price = parseFloat(priceMain.textContent.replace('$', ''));
      const discount = (cs_price * 20) / 100;
      const finalDiscountedPrice = (cs_price - discount).toFixed(2);

      priceMain.style.textDecoration = "line-through";

      const discountPrice = document.createElement('span');
      discountPrice.classList.add('discounted_price');
      discountPrice.textContent = `$${finalDiscountedPrice}`;
      discountPrice.style.marginLeft = '8px';

      div.appendChild(discountPrice);
      console.log(`Discounted price applied: $${finalDiscountedPrice}`);
    } else {
      priceMain.style.textDecoration = "none";
      console.log("No discount applied, original price restored.");
    }
  });
}


async function initRecommendations() {
    console.log("this function");
  const collectionHandle = "recommended-products-seguno";
  const container = document.getElementById("RecommendationList");
  if (!container) return;

  try {
    const response = await fetch(`/collections/${collectionHandle}/products.json?limit=50`);
    const data = await response.json();
    const products = data.products;
console.log("product", products);
    products.forEach(product => {
      const item = document.createElement("div");
      item.className = "recommendation-list__item d-flex align-items-start gap-5";
      item.setAttribute("data-variant-id", product.variants[0].id);

      item.innerHTML = `
        <a href="${product.url}" target="_blank" rel="noopener noreferrer" class="recommendation-list__thumb" style="flex: 0 0 70px; max-width: 70px;">
          ${product.images.length > 0 ?
            `<img src="${product.images[0].src}" alt="${product.title}" style="width: 100%; height: auto; border-radius: 0px;" />` :
            `<div style="width: 70px; height: 70px; background: #f3f3f3; border-radius: 6px;"></div>`}
        </a>
        <div class="recommendation-list__info" style="flex: 1 1 auto;">
          <a href="${product.url}" target="_blank" rel="noopener noreferrer" class="recommendation-list__title" style="display: block; font-weight: 400; color: #111; text-decoration: none; margin-bottom: 4px;">
            ${product.title}
          </a>
          <div class="recommendation-list__price d-flex align-items-center gap-1" style="color: #555;">
           <span class="price_div"> <span  data-price>$${product.variants[0].price}</span></span>
            <span class="icon_hangbag" onclick="window.addToCartWithDrawer(${product.variants[0].id}, 1)">
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 24 24" fill="none">
                <path d="M4 6.5H20V22H4V6.5Z" stroke="#272727"></path>
                <path d="M8 6.5V4.5C8 3.4 8.8 2.5 10 2.5H14C15.2 2.5 16 3.4 16 4.5V6.5" stroke="#272727"></path>
                <path d="M12 11V17" stroke="#272727"></path>
                <path d="M9 14H15" stroke="#272727"></path>
              </svg>
            </span>
          </div>
        </div>
      `;
      container.appendChild(item);
    });

    // After appending all products, run price adjustment
    await priceAdjustment(8008939372637);

  } catch (error) {
    console.error("Error fetching collection products:", error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initRecommendations();
});


